import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vee-language-warning',
  templateUrl: './language-warning.component.html',
  styleUrls: ['./language-warning.component.scss'],
  standalone: false,
})
export class LanguageWarningComponent {
  @Input() type?: 'only_german' | 'action' | 'result';
  constructor(public translate: TranslateService){}
}
